import { render, staticRenderFns } from "./ManageTeachersView.vue?vue&type=template&id=cdb214bc&"
import script from "./ManageTeachersView.vue?vue&type=script&lang=ts&"
export * from "./ManageTeachersView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports